// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type NotificationPaths = paths;
export const NOTIFICATION_SERVICE = "notification" as const;

/** Typed openapi-fetch client for the notification service (schema `notification`). */
export function createNotificationClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("notification", options);
}

export type NotificationClient = ReturnType<typeof createNotificationClient>;
